module.exports = __webpack_public_path__ + "static/media/loginbgi.ca471477.JPG";